import { useMemo } from 'react';
import { SelectField, TFormField } from '@monorepo/forms';
import { useI18n } from '@monorepo/i18n';

const DealerSelect = <
  TFormValues extends Record<string, any> = Record<string, any>
>(
  props: TFormField<TFormValues>
) => {
  const { t } = useI18n();

  const elements = useMemo(
    () => [
      {
        value: true,
        label: t('boolean.true')
      },
      {
        value: false,
        label: t('boolean.false')
      }
    ],
    [t]
  );

  return <SelectField options={elements} {...props} />;
};

export default DealerSelect;
